import { get, type RequestConfig } from "../shared/api-client";
import type { ApiItemResponse } from "@project/types/location";
import { JIVANDHARA_BASE } from "../admin/list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/payment-settings`;
const SILENT: RequestConfig = { showNotification: false };

export type PublicPaymentSettingsRecord = {
  id?: number | string;
  upi_id: string;
  qr_code_url: string;
  account_name: string;
  bank_name: string;
  account_number: string;
  ifsc_code: string;
  branch: string;
  pan_number: string;
  registration_80g: string;
  trust_registration_number: string;
  trust_address: string;
  contact_phone: string;
  contact_email: string;
  created_at?: string;
  updated_at?: string;
};

type PaymentSettingsResponse =
  | ApiItemResponse<PublicPaymentSettingsRecord>
  | PublicPaymentSettingsRecord
  | PublicPaymentSettingsRecord[]
  | {
      data?: PublicPaymentSettingsRecord | PublicPaymentSettingsRecord[] | null;
    }
  | undefined;

function unwrapPaymentSettings(
  response: PaymentSettingsResponse
): PublicPaymentSettingsRecord | undefined {
  if (!response) {
    return undefined;
  }
  if (Array.isArray(response)) {
    return response[0];
  }
  if (typeof response === "object" && "data" in response) {
    const value = response.data;
    if (Array.isArray(value)) {
      return value[0];
    }
    return value ?? undefined;
  }
  if (typeof response === "object" && "upi_id" in response) {
    return response as PublicPaymentSettingsRecord;
  }
  return undefined;
}

class PublicPaymentSettingsService {
  get = async (): Promise<PublicPaymentSettingsRecord | undefined> => {
    const response = await get<PaymentSettingsResponse>(`${BASE}/`, SILENT);
    return unwrapPaymentSettings(response);
  };
}

export const publicPaymentSettingsService = new PublicPaymentSettingsService();
